/* E-05: sparse previews use Shopify's tag-filtered Section Rendering API. */
(function () {
  'use strict';
  if (window.FizzyCollectionGroups) return;
  window.FizzyCollectionGroups = true;
  const instances = new Map();

  function collectionUrl(target, current, section) {
    const url = new URL(target, current);
    if (url.origin !== new URL(current).origin) throw new Error('Collection origin');
    const source = new URL(current);
    for (const [key, value] of source.searchParams) {
      if (key !== 'page' && key !== 'view' && key !== 'section_id' && key !== 'sections') {
        url.searchParams.append(key, value);
      }
    }
    url.searchParams.set('view', 'fizzy-all');
    if (section) url.searchParams.set('section_id', 'fizzy-collection-preview');
    return url;
  }

  function redirectFront(scope) {
    const link = scope.querySelector('[data-fizzy-front-redirect]');
    if (link?.dataset.target) {
      window.location.replace(collectionUrl(link.dataset.target, window.location.href, false).href);
    }
  }

  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    instances.set(root, controller);
    for (const group of root.querySelectorAll('[data-preview-url]')) {
      const cards = group.querySelector('.fz-groups__cards');
      const error = group.querySelector('[data-preview-error]');
      const pill = [...root.querySelectorAll('[data-fizzy-group-pill]')].find(link => link.dataset.fizzyGroupPill === group.dataset.fizzyGroup);
      let busy = false;
      async function load() {
        if (busy) return;
        busy = true;
        cards.setAttribute('aria-busy', 'true');
        error.hidden = true;
        try {
          const url = collectionUrl(group.dataset.previewUrl, window.location.href, true);
          const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Collection preview response');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = html.querySelector('[data-fizzy-preview-cards]');
          if (!source) throw new Error('Collection preview missing');
          if (controller.signal.aborted || !root.isConnected) return;
          if (!source.children.length) {
            pill?.remove();
            group.remove();
            return;
          }
          cards.replaceChildren(...source.childNodes);
          group.hidden = false;
          if (pill) pill.hidden = false;
          window.theme?.reinitProductGridItem?.(cards);
        } catch (failure) {
          if (!controller.signal.aborted) error.hidden = false;
        } finally {
          busy = false;
          cards.removeAttribute('aria-busy');
        }
      }
      group.querySelector('[data-preview-retry]').addEventListener('click', load, { signal: controller.signal });
      group.querySelector('[data-preview-close]').addEventListener('click', () => {
        error.hidden = true;
        group.querySelector('.fz-groups__all').focus();
      }, { signal: controller.signal });
      load();
    }
  }

  function start(scope) {
    redirectFront(scope);
    scope.querySelectorAll('[data-fizzy-collection-groups]').forEach(init);
  }
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of instances) {
      if (event.target.contains(root)) {
        controller.abort();
        instances.delete(root);
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  else start(document);
})();
